<template>
    <div class="title text-2xl font-semibold dark:text-white mb-3">
        <slot />
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'Title'
});
</script>

<style scoped lang="scss">
.title {

}
</style>
